import { useQuery } from '@tanstack/react-query';

import { useAuthContext } from '@cognite/e2e-auth';

import { QueryKeys } from '../../../../utils/queryKeys';

export const useFdmSpace = () => {
  const { client } = useAuthContext();

  return useQuery({
    queryKey: [QueryKeys.FDM_SPACE],
    queryFn: async () => {
      return client.spaces.list().then((res) => res.items);
    },
    meta: { error: { captureError: true, level: 'fatal' } },
  });
};
